<template>
	<div>
		<div
			class="modal fade product-tags"
			id="taggableProduct"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header " style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">Add Tags To Product(s)</h5>
						<button type="button" class="close" aria-label="Close" @click = "hideModal()">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>


					<div class="modal-footer" style = "flex: 0 0 auto">
						<div class="mt-2" style="text-align: center">
							<!-- <button type="button" @click="hideModal('cancel')" class="btn btn-secondary" data-dismiss="modal">D</button> -->
							<button
								type="button"
								class="btn btn-primary"
								@click = "hideModal()"
								>Close
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Multiselect from "vue-multiselect";

	export default {
		name: "AddTags",
		components: {
			Multiselect
		},
		data() {
			return {
				category_tag:null,
				style_tag:null,
				brand_tag:null,
				category_tags_List:[],
				style_tags_List:[],
				brand_tag_list:[],
				isLoadingData: false,
				add_cat:'Save',
				add_style:'Save',
				add_brand:'Save',
			};
		},
		mounted() {

			this.getTagsList()
		//	this.getProductAddedListData()
		},
		computed:{
			selectedProducts: {
				get() {
					return this.$store.state.product.selectedProducts;
				},
				set(val) {
					this.$store.state.product.selectedProducts = val
				}
			},
			actionSelectionControl: {
				set(val) {
					this.$store.state.product.actionSelectionControl = val
				},
				get() {
					return this.$store.state.product.actionSelectionControl
				}
			}
		},
		methods: {
			addTag(name, type){

				var pay = { title : name, id:''}

				if(type == 'category'){
					this.category_tag = pay
					this.category_tags_List.push(pay)
				}
				else if(type == 'brand'){
					this.brand_tag = pay
					this.brand_tag_list.push(pay)
				}
				else if(type == 'style'){
					this.style_tag = pay
					this.style_tags_List.push(pay)
				}

			},
			getTagsList(){

				this.$store.dispatch("product/getTagsForProduct").then((res) => {
					this.category_tags_List = res.category;
					this.brand_tag_list = res.brand;
					this.style_tags_List = res.style;
				})
			},
			hideModal(type){
				
				if((this.add_cat == 'Save' && this.category_tag) || (this.add_style == 'Save' && this.style_tag) || (this.add_brand == 'Save' && this.brand_tag)){
				  let isSaveData = confirm('Are you sure to close, please click on save to add the tags')
				  if(!isSaveData){
					  this.$emit("closeModal", type)
					  this.tags = null;
					  this.category_tag = null;
					  this.brand_tag = null;
					  this.style_tag = null
					  this.actionSelectionControl = false;
					  this.selectedProducts = []
				  }
				}
				else{
					this.$emit("closeModal", type)
					this.tags = null;
					this.category_tag = null;
					this.brand_tag = null;
					this.style_tag = null
					this.actionSelectionControl = false;
					this.selectedProducts = []
				}

			},

			saveTagsForProducts(type){
				 let vm = this;
			//	 this.isLoading =  true;
				 let payload = {
					 product_id:this.selectedProducts,
					 type:type
				 }

				 if(this.checkAction(type)){
					 if(type == 'category_product'){
						 payload.category_tag = this.category_tag;
						 this.add_cat = 'Loading'
					 }
					 if(type == 'brand_product'){
						 payload.brand_tag = this.brand_tag
						 this.add_brand = 'Loading'
					 }
					 if(type == 'style_product'){
						 payload.style_tag = this.style_tag
						 this.add_style = 'Loading'
					 }

					 this.$store.dispatch("product/addTags", payload ).then((res) => {
					//	 vm.isLoading =  false;

						if(type == 'category_product'){
							vm.add_cat = 'Edit';
						}

						if(type == 'style_product'){
							vm.add_style = 'Edit';
						}

						if(type == 'brand_product'){
							vm.add_brand = 'Edit';
						}
					 })
				 }

				},
			checkAction(type){

				if(type == 'category_product'){
					if(this.add_cat == 'Edit'){
						if(this.category_tag){
							this.category_tag = this.category_tags_List.find(e => e.title == this.category_tag.title)
						}
						this.add_cat = 'Save';
						return false
					}
					else{
						return true
					}
				}

				if(type == 'style_product'){
					if(this.add_style == 'Edit'){
						if(this.style_tag){
							this.style_tag = this.style_tags_List.find(e => e.title == this.style_tag.title)
						}
						this.add_style = 'Save';
						return false
					}
					else{
						return true
					}
				}
				if(type == 'brand_product'){
					if(this.add_brand == 'Edit'){
						if(this.brand_tag){
							this.brand_tag = this.brand_tag_list.find(e => e.title == this.brand_tag.title)
						}
						this.add_brand = 'Save';
						return false
					}
					else{
						return true
					}
				}

			},

		}
	};
</script>

<style lang="scss">

.product-tags {
	.multiselect__tag{
		text-transform:none !important;
	}
	.multiselect__single{
		text-transform: none !important;
		overflow: hidden;
	}
	.multiselect__option span{
		text-transform: none !important;
	}
}

</style>
